const getters = {
  regions: (state) => state.app.regions,
  stations: (state) => state.app.stations,
  company: (state) => state.app.company,
  isMobile: (state) => state.app.isMobile,
  tabsList: (state) => state.user.tabsList,
  nowTab: (state) => state.user.nowTab,
};
export default getters;



// WEBPACK FOOTER //
// ./src/store/getters.js